import { CalendarCog } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CalendarCogIcon = createLucideIcon(CalendarCog);
